module.exports = __webpack_public_path__ + "static/media/caret-down.1470b11b.svg";